import React from "react";
import { Link } from "react-router-dom";
import "../styles/Breadcrumb.css";
import { LuDot } from "react-icons/lu";
import { HiOutlineSwitchHorizontal } from "react-icons/hi";

const Breadcrumb = ({ items = [] }) => {
  return (
    <nav className="breadcrumb" aria-label="Breadcrumb">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;

        return (
          <span key={`${item.label}-${index}`}>
            {item.link && !isLast ? (
              <Link to={item.link} className="breadcrumb-link">
                {item.label}
              </Link>
            ) : (
              <>
                <span className="breadcrumb-current">{item.label}</span>
                <Link
                  to="/multimatters"
                  className="breadcrumb-link"
                  aria-label="Trocar caso"
                >
                  <HiOutlineSwitchHorizontal className="icon-offset ml-5" />
                </Link>
              </>
            )}

            {!isLast && <LuDot className="icon-offset" />}
          </span>
        );
      })}
    </nav>
  );
};

export default Breadcrumb;
